import { getAdminParentMessengerToken } from './admin-parent-auth.js';

// getJWTFromBridge extracts a JWT injected by native app/webview bridge.
export function getJWTFromBridge() {
  const token = (globalThis.__ANGKAS_JWT__ || '').trim();
  if (token) {
    // Keep token in-memory only; clear shared global immediately.
    delete globalThis.__ANGKAS_JWT__;
  }
  return token;
}

// getJWTFromURL extracts the JWT from the 'token' query parameter, then scrubs it from URL.
export function getJWTFromURL() {
  const params = new URLSearchParams(globalThis.location.search);
  const token = params.get('token') || '';
  if (token) {
    params.delete('token');
    const query = params.toString();
    const nextURL = `${globalThis.location.pathname}${query ? `?${query}` : ''}${globalThis.location.hash}`;
    globalThis.history.replaceState({}, document.title, nextURL);
  }
  return token;
}

// discoverJWTToken collects a JWT from native bridge, admin portal, or URL query.
export function discoverJWTToken() {
  return getJWTFromBridge() || getAdminParentMessengerToken() || getJWTFromURL();
}

// discoverLateJWTToken collects a JWT delivered after initial page load.
export function discoverLateJWTToken() {
  return getJWTFromBridge() || getAdminParentMessengerToken();
}
